var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.-Icons\\uD83C\\uDF88",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-72.000000, -120.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Basic-/-Line-/-Checked-/-Default",
    transform: "translate(72.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/CheckedIcon.3f40f858086d6ad09bb06ac57777b82b.svg";
export { ForwardRef as ReactComponent };